function setCookie(a, c) {
    document.cookie = a + "=" + c;
}
function getCookie(c) {
    var e = c + "=";
    if (document.cookie.length > 0) {
        var g = document.cookie.indexOf(e);
        if (g != -1) {
            g += e.length;
            var a = document.cookie.indexOf(";", g);
            if (a == -1) {
                a = document.cookie.length;
            }
            return document.cookie.substring(g, a);
        }
    }
}
export {setCookie,getCookie};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/CookieUtils.js